export const CART_ORDER_STORAGE_KEY = 'cartOrderData';
